/*jshint esversion: 6 */
window.devMode = !false;
import Vue from 'vue';
import _ from 'lodash';
import {DateTime } from "luxon";

import VueResource from 'vue-resource';
import VueRouter from 'vue-router';
import Vuex from "vuex";

Vue.use(VueResource);
Vue.use(VueRouter);
Vue.use(Vuex);


let supportLangs = ["ru", "kz", "en"];
let searchLang = location.search.replace("?lang=", "");

if (supportLangs.indexOf(searchLang) != -1) {
    history.pushState(0, '', '/');
    localStorage.lang = searchLang;
} else {
    searchLang = "";
}

Vue.mixin({
    data() {
        return {
            l_: _
        }
    },
    computed: {
        lang() {
            return searchLang ? searchLang : this.$store.state.lang ? this.$store.state.lang : "ru";
        }
    },
    methods: {
        rerender() {
            this.show = false
            this.$nextTick(() => {
                this.show = true
                console.log('re-render start')
                this.$nextTick(() => {
                    console.log('re-render end')
                })
            })
        }
    }
});

import "./assets/css/bootstrap-grid.css"
import "./assets/css/inspire-grid.css"

import "./assets/css/inspire-styles.css"

// import "./imports/prototypes/String.prototype.kzToLatin.js";
// import "./imports/prototypes/Number.prototype.toPhrase.js";
// import "./imports/prototypes/Array.prototype.findById.js";
// import "./imports/prototypes/Array.prototype.updateById";
// import "./imports/prototypes/Array.prototype.removeById";
// import "./imports/prototypes/Array.prototype.toTree";
// import "./imports/prototypes/Array.prototype.getOptions";
// import "./imports/prototypes/Date.js";
import "./imports/_i.js";
// import "./imports/toPhrase.js";
//import VueGearboxApi from "./imports/gearbox-tools.js";
//Vue.use(VueGearboxApi);
//import "./imports/basic-components.js";
//import "./imports/inspire-addons.js";
import "./imports/bbcode.js";
//import "./classes/iFormData.js";

//import "./imports/graphql.js";

//import GearboxAuth from './modules/auth/auth-graphql.gearbox-plugin.js';
//Vue.use(GearboxAuth);


Vue.http.options.root = '//' + location.host + '/api/v1';
Vue.http.options.credentials = true;
Vue.config.productionTip = false;



import App from "./App.vue";

import store from './store.js';
import routes from './routes.js';
const router = new VueRouter({ routes });

//import store from "./store";

//Vue.http.options.root = location.protocol+'//next.iwep.kz/api/v1';
Vue.http.options.root = location.protocol + '//' + location.host + '/api/v1';
Vue.http.options.credentials = true;



//Fonter.load(["Fira Sans","Open Sans","Caveat","Merriweather"]);
//Fonter.load(["Cormorant Garamond","Open Sans","Caveat","Merriweather"]);
//Fonter.load(["Plumb", "Open Sans", "Caveat", "Merriweather"]);



document.title = "ИНСТИТУТ МИРОВОЙ ЭКОНОМИКИ И ПОЛИТИКИ";


import PostBack from "./UI/post-back.vue";
Vue.component("post-back", PostBack);


let { _i } = window;



(function () {
    var link = document.querySelector("link[rel*='icon']") || document.createElement('link');
    link.type = 'image/x-icon';
    link.rel = 'shortcut icon';
    link.href = '/src/apps/iwep.kz/assets/img/favicon.ico';
    document.getElementsByTagName('head')[0].appendChild(link);
})();

String.prototype.toHttps = function () {
    if (!this) return "";
    return this.replace(/http:\/\/content\.iwep\.kz/gim, "//content.iwep.kz/");
}

let iseo = {
    meta: {
        lang: localStorage.lang || "ru",
        lang_support: true,
        title: {},
        description: {},
        website_name: {},
        section: {},
        image: "",
        metas_injected: false,
        tags: {}
    },
    injectMeta(k, v) {
        if (this.meta.tags[k]) {
            this.meta.tags[k].content = v;
        } else {
            let meta = document.createElement('meta');
            meta.name = k;
            meta.content = v;
            document.head.appendChild(meta);
            this.meta.tags[k] = meta;
        }
    },
    setAll() {
        let { meta: { lang, title = {}, section, image, description, website_name } } = this;
        let ttl = title[lang] || "";
        if (section[lang]) {
            ttl += " | " + section[lang];
        }
        if (website_name[lang]) {
            ttl += " | " + website_name[lang];
        }
        document.title = ttl;
        this.injectMeta('og:title', ttl);
        this.injectMeta('description', description && description[lang]);
        this.injectMeta('og:description', description && description[lang]);
        this.injectMeta('og:image', image);

    },
    load(_seo) {
        this.meta = Object.assign({}, this.meta, _seo);
        this.setAll();
    }
}

Vue.mixin({
    beforeRouteEnter(to, from, next) {
        next(vm => vm.seo && iseo.load(vm.seo));
    },
    computed: {
        tr() { return this.$store.getters.translates; },
        trRaw() { return this.$store.state.translates; },
        lang() { return this.$store.state.lang; }
    }
});
iseo.load({ website_name: { en: "IWEP", ru: "ИМЭП", kz: "ӘЭСИ" } })

//Vue.importComponents(['back-to-top', 'i-paginator', 'i-image-viewer', 'i-video']);


Vue.filter('short', function(value, ln = 128) {
    let newVal;
    if (!value) return "";
    if (value.length > ln) {
        newVal = value.substring(0, ln);
        if (newVal[ln] != ' ') newVal = newVal + "...";
    } else {
        newVal = value;
    }

    return newVal;
});

Vue.filter('date', function(value, dateFormat = "dd-LL-yyyy HH-mm") { // HH-mm
    //dateFormat = 'MMMM Do YYYY, h:mm:ss a'
    if (!value) return "Укажите дату";

    if (typeof value === 'string') {
        return DateTime.fromISO(value, { zone: 'utc' }).toFormat(dateFormat)
    }

    if (value instanceof Date) {
        return DateTime.fromJSDate(value).toFormat(dateFormat)
    }


    if (value instanceof DateTime) {
        return value.toFormat(dateFormat)
    }


});

import iBtn from "./components/button.vue";
Vue.component('btn', iBtn);
import iVideo from "./components/i-video.vue";
Vue.component('i-video', iVideo);


new Vue({
    el: '#app',
    render: h => h(App),
    router,
    store
});